<template>
  <v-container>
    <v-row>
      <v-col cols="12" lg="10" offset-lg="1">
        <h2 class="title mb-3">ダッシュボード</h2>
        <v-row>
          <v-col lg="6">
            <h3 class="subtitle-1 mb-4">記事データ</h3>
            <v-divider style="width: 400px" />
            <v-card class="my-5" width="150" outlined to="/admin/posts">
              <v-card-subtitle> 公開記事本数 </v-card-subtitle>
              <v-card-text>
                <div class="text-center display-2">
                  {{ publishedPostCount }}
                </div>
              </v-card-text>
            </v-card>

            <v-divider />
            <v-row class="py-5">
              <v-col md="10" lg="5">
                <v-card to="/admin/posts">
                  <v-card-text>
                    <v-icon large> mdi-pencil </v-icon>
                    <span class="subtitle-1 ml-4">記事を管理する</span>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col md="10" lg="6" offset-lg="1">
                <v-card to="/admin/settings">
                  <v-card-text>
                    <v-icon large> mdi-cogs </v-icon>
                    <span class="subtitle-1 ml-4">サイトの設定をする</span>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col lg="6">
            <h3 class="subtitle-1 mb-4">お知らせ</h3>
            <v-divider />
            <v-spacer />
            <div v-if="supportArticles.length !== 0">
              <v-row
                v-for="(article, index) in supportArticles"
                :key="index"
                class="py-2"
              >
                <v-col md="4">
                  <span class="caption">{{ article.updatedAt | moment }}</span>
                </v-col>
                <v-col md="8">
                  <a
                    :href="article.publicUrl"
                    class="subtitle-2"
                    target="_blank"
                  >
                    {{ article.title }}
                  </a>
                </v-col>
              </v-row>
              <v-divider class="ml-1" style="width: 95%" />
            </div>
            <div v-else>
              <p class="caption py-3 pl-2 font-weight-light">
                お知らせはありません
              </p>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import headUtilsMixin from '@/mixins/head_utils'

export default {
  filters: {
    moment: function (val) {
      if (val) {
        return moment(val).format('YYYY年M月D日 HH時mm分')
      }
    }
  },
  mixins: [headUtilsMixin],
  data: () => {
    return {
      pageTitle: 'ダッシュボード',
      supportArticles: [],
      publishedPostCount: 0
    }
  },
  mounted: function () {
    axios.get('/api/support_articles').then(
      ({ data }) => {
        this.supportArticles = data
      },
      (error) => {
        const payload = {
          status: error.response.status,
          message: error.response.data.errors.toString()
        }
        this.$store.dispatch('SystemMessageStore/createMessage', payload)
      }
    )
    axios.get('/api/published_post_count').then(
      ({ data }) => {
        this.publishedPostCount = data.publishedPostCount
      },
      (error) => {
        const payload = {
          status: error.response.status,
          message: error.response.data.errors.toString()
        }
        this.$store.dispatch('SystemMessageStore/createMessage', payload)
      }
    )
  },
  methods: {}
}
</script>

<style scoped></style>
